var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('div',{staticClass:"p-2 w-100 h-100"},[_c('Pie',{ref:"chart w-100 h-100",attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }